import callCrmApi from '../../crmService/crmService';

const basePath = '/frontend/api/one-to-one/tiffany';

export const getTiffanyMemberLevelAndGender = () => callCrmApi({
  method: 'POST',
  endpoint: `${basePath}/common/get-tiffany-member-level-and-gender`
});
